<ng-container *ngIf="firstRunReactEnabled" ohpLazyView ngModulePath="first-run-react#FirstRunReactModule"></ng-container>
<ng-container *ngIf="!firstRunReactEnabled" ohpLazyView ngModulePath="first-run#FirstRunModule"></ng-container>
